import { motion } from "framer-motion";
import Layout from "../components/layouts/main";
import {
	Heading,
	HStack,
	Link,
	useBreakpointValue,
	VStack,
	Flex,
	Spinner,
	Center,
	Switch,
	Text,
} from "@chakra-ui/react";
import InfoBlock from "../components/home/infoBlock";
import { useEffect, useState } from "react";
import api from "../utils/axios";
import BadgeCard from "../components/badges/BadgeCard";
import { chakra } from '@chakra-ui/react';
import { formatNumber } from "../utils/helper";

const MotionHeading = motion(Heading);
const refLink = 'https://scroll.io/canvas/invite/DBQC1';

const BadgesPage = () => {
	const isMobile = useBreakpointValue({ base: true, md: false });
	const [data, setData] = useState({});
	const [loading, setLoading] = useState(true); // Состояние для отслеживания загрузки данных
	const [sortOrder, setSortOrder] = useState('desc'); // Состояние для сортировки

	useEffect(() => {
		const getBadges = async () => {
			try {
				const response = await api.get('/badges/canvas-info');
				setData(
					response.data
				);
			} catch (error) {
				console.error("Error fetching badges:", error);
			} finally {
				setLoading(false); // Устанавливаем состояние загрузки в false после завершения запроса
			}
		};

		getBadges();
	}, []);


	// Функция для сортировки бейджей по количеству минтов
	const handleSortChange = () => {
		setSortOrder(prevOrder => (prevOrder === 'asc' ? 'desc' : 'asc'));
	};

	const sortedBadges = data.badges?.slice().sort((a, b) => {
		if (sortOrder === 'asc') {
			return a.count - b.count;
		} else {
			return b.minted_amount - a.minted_amount;
		}
	}) || [];

	return (
		<Layout>
			<VStack spacing={2} textAlign="center">
				<MotionHeading
					fontSize="clamp(1.5em, 2.8vw, 2.4em)"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 1 }}
					textAlign={"center"}
					m={!isMobile ? 6 : 1}
				>
					Badges on Scroll Canvas
				</MotionHeading>

				<HStack
					spacing={!isMobile ? 6 : 2}
					wrap="wrap"
					justify="center"
					textAlign="center"
				>
					<InfoBlock label="Total canvas minted" value={loading ? <Spinner size="md" /> : formatNumber(data.canvasCount)} isMobile={isMobile} />
					<InfoBlock label="Total badges minted" value={loading ? <Spinner size="md" /> : formatNumber(data.badgesCount)} />
				</HStack>
			</VStack>

			<VStack spacing={8} align="center" pt={8}>
				<HStack w={'100%'} textAlign={"center"}>
					<Link isExternal href={refLink} color="#FF684B" style={{ textDecoration: 'none' }} w={'100%'} >
						<Flex bg="#FEF0DD" p={4} borderRadius="15px" textAlign="center" justifyContent={"center"} fontWeight={"bold"} fontSize={!isMobile ? '16px' : '12px'}>
							<Flex flexFlow={"column"} className="heartbeat-slow">
								<span>MINT YOUR SCROLL CANVAS</span>
								<chakra.span color="gray.800" fontSize={"13px"}>You get 50% off mint fee</chakra.span>
							</Flex>
						</Flex>
					</Link>
				</HStack>
			</VStack>

			<Heading as="h2" textAlign="center" fontSize="clamp(1.2em, 2.2vw, 1.8em)" pt={8} >
				Badges Minted Info
			</Heading>

			<VStack spacing={8} align="center" pt={8} pb={8}>
				<HStack spacing={4} mb={4} alignItems="center" justifyContent={"center"}>
					<Text fontSize="md" fontWeight="bold">
						Sort by Minted Amount
					</Text>
					<Switch
						isChecked={sortOrder === 'asc'}
						onChange={handleSortChange}
						size="md"
						colorScheme="orange"
						aria-label="Sort badges"
					/>
					<Text fontSize="md" fontWeight="bold">
						{sortOrder === 'asc' ? 'Ascending' : 'Descending'}
					</Text>
				</HStack>

				<HStack wrap="wrap" spacing={4} justify="center" alignItems="stretch">
					{!loading ? sortedBadges.map((badge, index) => (
						<motion.div
							key={index}
							initial={{ opacity: 0, scale: 0.9 }}
							animate={{ opacity: 1, scale: 1 }}
							transition={{ duration: 0.5 }}
							textAlign={"center"}
						>
							<BadgeCard badge={badge} />
						</motion.div>
					)) : <Center><Spinner></Spinner></Center>}
				</HStack>
			</VStack>
		</Layout>
	);
};

export default BadgesPage;
